<template>
	<div class="personHome d-flex j-sb a-start">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent d-flex f-wrap">
			<!-- 消息 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{$t('admin.message')}}</h3>
					</div>
					<div class="table font-light line-mn">
						<dl>
							<dt class="d-flex">
								<span>{{$t('admin.messageName')}}</span>
								<span>{{$t('admin.read')+'/'+$t('admin.unread')}}</span>
								<span>{{$t('admin.messageTime')}}</span>
								<span>{{$t('admin.operate')}}</span>
							</dt>
							<dd class="d-flex pointer" v-for="(item,index) in list" :key="index">
								<span class="nowrap2"><a @click="goToPage('/messageDetail?id=' + item.id)" class="link">{{item.title}}</a></span>
								<span>{{item.readStatus?$t('admin.read'):$t('admin.unread')}}</span>
								<span>{{item.time}}</span>
								<span class="d-flex j-center a-center">
									<a class="d" @click="delMessage(item.id)"></a>
								</span>
							</dd>
						</dl>
					</div>
				</div>
				<div class="pagination">
					<el-pagination
						@current-change="handleCurrentChange"
						:page-size="10"
						layout="prev, pager, next"
						:total="total"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'MessageList',
  components: {
    
  },
  data() {
    return {
		list:[],
		pagination: {
        pageNo: 1,
        pageSize: 10,
      },
      // 数量
      total: 0,
	}
  },
  created:function(){
	this.getList();
  },
  methods:{
	getList() {
      this.$axios
        .post("member/messagePage", this.pagination)
        .then((res) => {
          this.list = res.data.list;
          this.total = res.data.total;
        })
        .catch((err) => {});
    },
	delMessage(id){
		this.$axios
        .get(`member/deleteMessage?id=${id}`)
        .then((res) => {
          if(res.code==200){
			this.$message({
				message: this.$t('commom.deleteSucess'),
				type:'success'
			});
			this.getList();
		  }
        })
        .catch((err) => {});
	},
	// 点击翻页
    handleCurrentChange(current) {
      this.pagination.pageNo = current;
      // 更新
      this.getProductVoList();
    },
	// 页面跳转
    goToPage(path, query = {}) {
      this.$router.push({
        path,
        query,
      });
    },
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		
		.psLeftContent{
			width: 100%;
			.toPage{
				margin-left: .15rem;
				input{
					width: .4rem;
					height: .4rem;
					border-radius: 5px;
					background: #fff;
					text-align: center;
					margin: 0 5px;
					padding: 0 5px;
				}
			}
			.item{
				width: 50%;
				margin-bottom: .2rem;
				&.w100{
					width: 100%;
					dd:hover,dd:hover a{
						color: #2657db;
					}
				}
			}
			.table{
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						.d{
							width: .18rem;
							height: .18rem;
							background: url(@/assets/Icons/deletGray.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/deletBlue.png);
							}
						}
						&:nth-of-type(1) {
							width: calc(75% - 1rem);
						}
						&:nth-of-type(2) {
							width: 13%;
						}
						&:nth-of-type(3) {
							width: 12%;
						}
						&:last-child{
							width: 1rem;
							text-align: center;
						}
					}
				}
			}
		}
		@media (max-width: 640px) {
			padding: .2rem;
			.psLeftContent{
				.table{
					dl{
						span{
							
							&:nth-of-type(1) {
								width: 3rem;
								padding-right: .2rem;
							};
							&:nth-of-type(2),
							&:nth-of-type(3){
								width: 1.2rem;
							}
						}
					}
				}
			}
		}
	}
</style>
